/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingQueryTenants extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MasterAccountBillingQueryTenants");
    }

    getFixupPrototypeFunction() { return MasterAccountBillingQueryTenants.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingQueryTenants>): MasterAccountBillingQueryTenants {
        let obj = Object.assign(new MasterAccountBillingQueryTenants(), model);
        MasterAccountBillingQueryTenants.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingQueryTenants>): MasterAccountBillingQueryTenants {
        if (!model) return null;
        return MasterAccountBillingQueryTenants.newInstance(<MasterAccountBillingQueryTenants> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingQueryTenants) {
        if (!obj) return;

        models.MasterAccountBillingQueryTenants.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingQueryTenants): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountBillingQueryTenants.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of tenants
     */
    tenants_ids: Array<string>;

}
